// let wishlistElem = document.querySelector('.MuiBadge-root');
// let cartDrawer = document.querySelector('cart-drawer .drawer');
// let cartIcon = document.getElementById('cart-icon-bubble');

// // cartIcon.addEventListener('click',function(){
// //     console.log('clicked');
// //     if(cartDrawer.classList.contains('active')){
// //         console.log('clicked 01');
// //         wishlistElem.style.display = 'none';
// //     }else{
// //         console.log('clicked 02');
// //         wishlistElem.style.display = 'block';
// //     }
// // })

// const observer = new MutationObserver((mutations) => {
//     mutations.forEach((mutation) => {
//         if (mutation.attributeName === "class") {
//             const isOpen = cartDrawer.classList.contains('active');
//             wishlistElem.style.display = isOpen ? 'none' : 'flex';
//         }
//     });
// });

// observer.observe(cartDrawer, { attributes: true });


// Use a more direct selector
const wishlistElem = document.querySelector('.MuiBadge-root');
// Select the custom element directly since the classes are ON it
const cartDrawer = document.querySelector('cart-drawer'); 

if (cartDrawer && wishlistElem) {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.attributeName === "class") {
                const isOpen = cartDrawer.classList.contains('active');
                // console.log('Drawer status changed. Is Open:', isOpen); // Debugging
                wishlistElem.style.display = isOpen ? 'none' : 'flex';
            }
        });
    });

    observer.observe(cartDrawer, { attributes: true });
} else {
    console.error("Could not find cartDrawer or wishlistElem in the DOM.");
}

